import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';

const useStyles = buildUseStyles('CheckIcon', ((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
})));

const CheckIcon = () => {
  const classes = useStyles();
  return (
    <Box
      className={classes.root}
    >
      <Tooltip title={'Value already saved.'}><CheckCircleIcon color={'secondary'} /></Tooltip>
    </Box>
  );
};

export default CheckIcon;
